import { partners } from '@/mocks/services';

export default function PartnerSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
            他们都在与果冻传媒合作
          </h2>
          <p className="text-sm text-foreground-500">
            来自不同行业的领先品牌，选择果冻传媒作为内容营销合作伙伴
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {partners.map((partner) => (
            <div
              key={partner.name}
              className="flex flex-col items-center justify-center py-8 px-4 bg-background-50 border border-background-200/60 rounded-lg hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <span className="font-heading text-lg font-semibold text-foreground-800 mb-1">
                {partner.name}
              </span>
              <span className="text-xs text-foreground-400">{partner.industry}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}